import React from "react"
import propTypes from "prop-types"
import { Table } from "reactstrap"
import { groupProductsByProduct } from "../helpers/groupProductsByProduct"

const ProductsTable = ({ products }) => {
    // Del Modal de Nueva Factura
    // Tabla que muestra los productos agrupados por producto, con detalles de cada ticket asociado
    return (
        <div className="mt-4 table-responsive">
            <Table
                size="sm"
                bordered
                style={{
                    borderColor: "#9FA4A9",
                    borderWidth: "1.5px"
                }}
            >
                <thead>
                    <tr>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Ticket : Cantidad
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Descripción
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Unidad SAT
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Clave SAT
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Impuestos
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Cantidad Total
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Val Unit
                        </th>
                        <th style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}>
                            Importe
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {products.length === 0 ? (
                        <tr>
                            <td
                                colSpan="8"
                                className="text-center text-muted py-4"
                                style={{ borderColor: "#9FA4A9", borderWidth: "1.5px" }}
                            >
                                Ningún dato disponible
                            </td>
                        </tr>
                    ) : (
                        Object.entries(
                            groupProductsByProduct(products)
                        ).map(([productKey, productData]) => {
                            return (
                                <React.Fragment key={productKey}>
                                    {productData.tickets.map((ticket, ticketIndex) => (
                                        <tr key={`${productKey}-${ticket.ticketId}-${ticketIndex}`}>
                                            <td style={{
                                                borderColor: "#9FA4A9", borderWidth: "1.5px"
                                            }}>
                                                <strong>N° {ticket.ticketFolio}:</strong>
                                                {" "}{ticket.quantity} pieza(s)
                                            </td>
                                            {ticketIndex === 0 && (
                                                <>
                                                    <td
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        {productData.description}
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        {productData.unitSat}
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        {productData.satCode}
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        {productData.taxLabel}
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle text-center"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        <strong>
                                                            {productData.totalQuantity} pieza(s)
                                                        </strong>
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        ${productData.unitPrice.toFixed(2)}
                                                    </td>
                                                    <td 
                                                        rowSpan={productData.tickets.length}
                                                        className="align-middle"
                                                        style={{
                                                            borderColor: "#9FA4A9",
                                                            borderWidth: "1.5px"
                                                        }}
                                                    >
                                                        <strong>
                                                            ${productData.totalAmount.toFixed(2)}
                                                        </strong>
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </React.Fragment>
                            )
                        })
                    )}
                </tbody>
            </Table>
        </div>
    )
}

ProductsTable.propTypes = {
    products: propTypes.array.isRequired
}

export default ProductsTable
